import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType, ResponseType, ResponseListType, ResponseCodeType } from "@/common/types/common";
import type { ResultType } from "@/common/types/result";

export async function resultList(
    owner_id: string,
    query?: QueryType
) {

    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `account/analysis/${owner_id}/result/list${queryString}`
    );
}

export async function resultAdd(
    owner_id: string
) {
    return await clientAxios.post(
        `account/analysis/${owner_id}/result/create`,
        null
    );
}

export async function resultPatch(
    result_id: string,
    payload: Partial<ResultType>
) {
    return await clientAxios.patch(
        `account/analysis/result/${result_id}/patch`,
        { payload }
    );
}

export async function resultDel(
    result_id: string,
) {
    return await clientAxios.del(
        `account/analysis/result/${result_id}/delete`,
    );
}

export async function resultResume(
    result_id: string,
) {
    return await clientAxios.post(
        `account/analysis/result/${result_id}/resume`,
        null
    );
}
